import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';
import { AppShortcut } from '../../models';
import { NxIconService } from '../../../../core/services/icon.service';
import { inject } from '@angular/core';

@Component({
  selector: 'app-launcher-grid',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, MatIconModule, MatRippleModule],
  template: `
    <div class="grid grid-cols-3 gap-4">
      @for (app of apps(); track app.id) {
        <a
          [routerLink]="app.route"
          matRipple
          class="relative flex flex-col items-center rounded-pmdf-card px-0.5 py-0 "
        >
          <div class="flex h-16 w-16 items-center justify-center rounded-pmdf-card bg-pmdf-primary-soft/5">
            @if (app.svgIcon) {
              <mat-icon [svgIcon]="app.svgIcon" [class]="'icon-3xl ' + app.iconClass"></mat-icon>
            } @else if (app.icon) {
              <mat-icon [class]="'icon-3xl ' + app.iconClass">{{ app.icon }}</mat-icon>
            }
          </div>
          <span class="text-center text-sm font-light leading-tight text-pmdf-text-primary mt-1">
            {{ app.label }}
          </span>
          @if (app.badge && app.badge > 0) {
            <span
              class="absolute right-2 top-2 flex h-5 min-w-5 items-center justify-center rounded-full bg-pmdf-danger px-1 text-[10px] font-bold text-pmdf-surface"
            >
              {{ app.badge > 99 ? '99+' : app.badge }}
            </span>
          }
        </a>
      }
    </div>
  `,
})
export class AppLauncherGrid {
  // Garante que todos os SVGs estejam registrados
  private readonly _iconService = inject(NxIconService);

  apps = input.required<AppShortcut[]>();
}
